import React from "react";
import { Flex, Text } from "@radix-ui/themes";
import * as Toast from "@radix-ui/react-toast";
import { useToast } from "../../context/ToastContext";
import "./toastStyle.css";

export function ToastAlert() {
  const { toasts, clearToasts } = useToast();

  return (
    <Toast.Provider swipeDirection="right" duration="5000">
      {toasts.map((toast) => (
        <Toast.Root key={toast.id}
          className="ToastRoot"
          open={true}
          style={{ backgroundColor: "var(--gray-a12)", justifyContent: "center", borderRadius: "var(--radius-2)",
            marginBottom: "8px" }}>
          <Toast.Description className="ToastDescription" asChild style={{ color: "var(--gray-contrast)" }}>
            <Flex px="3" py="2">
              <Text style={{ color: "var(--color-panel-solid)" }} size="2" weight="medium">
                {toast.message}
              </Text>
            </Flex>
          </Toast.Description>
        </Toast.Root>
      ))}

      <Toast.Viewport className="ToastViewport" style={{display: "flex", flexDirection: "column", gap: "8px"}}/>
    </Toast.Provider>
  );
}
